import { render, staticRenderFns } from "./LeftBar.vue?vue&type=template&id=3b74122f&scoped=true"
import script from "./LeftBar.vue?vue&type=script&lang=js"
export * from "./LeftBar.vue?vue&type=script&lang=js"
import style0 from "./LeftBar.vue?vue&type=style&index=0&id=3b74122f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b74122f",
  null
  
)

export default component.exports